import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Deliverables() {
  const items = [{
    title: 'The 7-Day Rapid Reset Guide',
    desc: 'A step-by-step roadmap to extinguish systemic heat.'
  }, {
    title: 'The "Flash-Point" Framework',
    desc: 'Learn to identify and kill your specific triggers in 48 hours.'
  }, {
    title: 'The 2 AM Emergency Cooling Guide',
    desc: 'Exactly what to do when a flare hits so you can get back to sleep in minutes.'
  }, {
    title: 'The Night-Ready Kitchen Prep',
    desc: 'A curated list of the "Hidden Three" triggers you must remove today.'
  }, {
    title: 'The 3-Ingredient Nightly "Golden Latte"',
    desc: 'The delicious ritual that calms your joints while you sleep.'
  }];
  return <section className="py-24 px-6 bg-white" data-id="element-31">
      <div className="max-w-4xl mx-auto" data-id="element-32">
        <FadeIn data-id="element-33">
          <h2 className="text-3xl md:text-4xl text-teal mb-12 text-center" data-id="element-34">
            What You Get
          </h2>

          <div className="grid gap-6" data-id="element-35">
            {items.map((item, index) => <div key={index} className="flex items-start gap-4 p-6 rounded-xl bg-cream border border-sage/10 hover:border-sage/30 transition-colors" data-id="element-36">
                <CheckCircle2 className="w-6 h-6 text-teal shrink-0 mt-1" data-id="element-37" />
                <div data-id="element-38">
                  <h4 className="text-xl font-serif text-teal mb-2" data-id="element-39">
                    {item.title}
                  </h4>
                  <p className="text-charcoal/70" data-id="element-40">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}